//components
import { 
	ErrorBoundary, 
	SelectComponent, 
	ControlPanelManager,
	RelationshipCreatorForm,  
} from 'component-library';

import { ConceptEditingBlock } from './ConceptEditingBlock/ConceptEditingBlock.js';
import { convertSortSelectedConceptsPipe } from './convertSortSelectedConceptsPipe/convertSortSelectedConceptsPipe.js';
import { ConceptRelationshipCreatorForm } from '../components/ConceptRelationshipCreatorForm/ConceptRelationshipCreatorForm.js';
//helpers
import { objectEmpty, capitalize } from 'helper-functions-library';
import { otherConcept } from '../functions/otherConcept/otherConcept.js';
import { pluralConcepts } from '../functions/pluralConcepts/pluralConcepts.js';
import { useDidUpdateEffect } from 'hooks-library';
//styles
import styles from './conceptBlockStyles.css';
//Wordpress/react
const { InspectorControls, useBlockProps } = wp.blockEditor;
const { useEffect, useState, renderToString } = wp.element;
const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
import metadata from '../../../includes/blocks/concept-block/block.json';

/*TODO
-look at no block storage of attributes e.g. in the html - this could recude a lot.
*/
registerBlockType( metadata, {
	edit: (props) => {
		return (<ConceptBlock {...props} />);
	},
	save: () => {
	    return null;
	},
});

/*this component creates the presentation of each concept in the editor 
Props:
	concept: (string) the concept being displayed
	frontend_pre_fix: (string) any prefix to the title
	more_info_output: (object) object of settings to display
	selected_concepts: (object) the data to present
	ASC_DESC: (string) how to order the concepts
	onchange: (function) to remove a concept
	isSelected: (boolean) if the block is selected 
*/
export function ConceptBlock (props) {

	let { 
			attributes, 
			setAttributes, 
			isSelected 
		} = props,
		other = otherConcept(attributes.concept),
		metaData = framework_info?.tableSettings?.['rf_'+attributes.concept+'_framework_relationships']?._table_columns,
		metaDataFormattedForControls = Object.values(metaData)
			.filter((m)=> {
				if (m._column_name !== 'id_framework' && m._column_name !== 'id_'+attributes.concept && m._column_name !== 'id_'+attributes.concept+'_framework_relationships') {
					return true;
				}
			})
			.map((m)=>{
				return {name:m?.title ?? m._column_name , id:m._column_name, use:true};
			}),
		fullControllSettings = metaDataFormattedForControls.concat([
			{name:'URI', id:attributes.concept+'_unique_id', use:true},
			{name:'Categories', id:'category', use:true}, 
			{name:'Found in these frameworks', id:'framework', use:true},
			{name:'Linked '+other, id:other, use:true},
			{name:'New research', id:'publication', use:true},
		]),
		legacyFullControllSettings = fullControllSettings.map((s)=>{ //LEGACY, look to remove
			if ( !objectEmpty(attributes.more_info_output) && attributes.more_info_output[s.id] == undefined) {
				s.use = false;
			}
			return s;
		}),
		[controlSettings, setControlSettings] = useState(legacyFullControllSettings); 

	useDidUpdateEffect(() => {
		setAttributes({...attributes, order_by: attributes.concept+'_local_numbering', more_info_output:{}});
		setControlSettings(fullControllSettings);
	 }, [attributes.concept]);
	 
	 useDidUpdateEffect(() => {
		
		let formatted ={}; 
//LEGACY - look to change in the future
		controlSettings.forEach((s)=>{
			if (s.use) {
				formatted[s.id] = s.name;
			}
		});

		setAttributes({...attributes, more_info_output:formatted});
	 }, [controlSettings]);
	 
/*LEGACY*/
	//legacy for when this was an array
	if ( attributes.more_info_output !== undefined && Array.isArray(attributes.more_info_output) ) {
		attributes.more_info_output.reduce((a, v) => ({ ...a, [v]: v}), {}) 
	}
	//check if server render is set - for backward compatibility issues
	if (attributes.serverRender == '' && (attributes.selected_concepts !== undefined && !objectEmpty(attributes.selected_concepts)) ) {
		let serverRender = renderToString(< ConceptEditingBlock {...attributes}/>);
		
		setAttributes({serverRender:serverRender});
	}
	
//TODO search all posts/pages for the block and look at attributes - are any without serverRender (fix). Are any with .more_info_output as an array (fix)
//TODO after that clean up selected_concepts to be an array, also, probably more_info_outputs too.
/*********/

	//handle input changes by adding the current attributes and setAttributes function
	function handleAttributes(event) {
		
		let {name, value} = event.target,
			newState = JSON.parse(JSON.stringify(attributes));			 
			
		if (name == "defaultOpen") { 
			value = JSON.parse(value); //convert to boolean	
		}; 	
		
		newState[name] = value;
		setAttributes(newState);
	}
	
	useDidUpdateEffect(() => {
		let newState = JSON.parse(JSON.stringify(attributes)),
			sortedSelectedConcepts = convertSortSelectedConceptsPipe({
				selectedConcepts: newState.selected_concepts, 
				sortBy: newState.order_by, 
				direction: newState.ASC_DESC
			});

		setAttributes({
			...attributes, 
			serverRender: renderToString(< ConceptEditingBlock {...newState} selected_concepts={sortedSelectedConcepts}/>)
		});
	 }, [
		attributes.ASC_DESC, 
		attributes.defaultOpen, 
		attributes.frontend_pre_fix,
		attributes.more_info_output,
		attributes.order_by,
		attributes.selected_concepts,
	]);
	
	function handleCurrentSelectionsChange(currentSelections) {
		let newState = JSON.parse(JSON.stringify(attributes)),
			selected = {},
			selectConcept = currentSelections.map((c)=> {

				if (typeof c.category == 'string') {
					c.category = JSON.parse(c?.category);
				}
				if (typeof c[other] == 'string') {
					c[other] = JSON.parse(c?.[other]);
				}

				selected[c['id_'+attributes.concept]] = c;
			});
			
		setAttributes({
			...newState, 
			selected_concepts: selected, //LEGACY of this needing to be an object
		});
	}
	
	function removeConcept(event) {
		
		let {name} = event.target,
			newState = JSON.parse(JSON.stringify(attributes));			 
	
		delete 	newState.selected_concepts[name];
		
		setAttributes(newState);
	}
	
	return <div {...useBlockProps()}><ErrorBoundary>
		<div className={styles.editConceptHolder}>
			<ConceptEditingBlock 
				concept={attributes.concept}
				frontend_pre_fix={attributes.frontend_pre_fix}
				more_info_output={attributes.more_info_output}
				selected_concepts={convertSortSelectedConceptsPipe({
					selectedConcepts: attributes.selected_concepts, 
					sortBy: attributes.order_by, 
					direction: attributes.ASC_DESC
				})}
				isSelected={isSelected}
				onClick={removeConcept}
				defaultOpen={attributes.defaultOpen}
			/>
		</div>
		<InspectorControls>
			<div className={styles.inspectorControlsHolder}>
				<h2 className={styles.blockSidebarHeader}>1. Choose the concept:</h2>
				<span>Note - switching will erase any existing {pluralConcepts(attributes.concept)}.</span>
				<SelectComponent 
					current={attributes.concept} 
					name='concept'
					onChange={handleAttributes} 
					options = {[
						{value:'question', label:'Question ¿?'},
						{value:'strategy', label:'Strategy ✎'},
					]}
				/>
				<h2 className={styles.blockSidebarHeader}>2. Add {pluralConcepts(attributes.concept)}:</h2>
				<ConceptRelationshipCreatorForm 
					concept = {attributes.concept} 
					onCurrentSelectionsChange={handleCurrentSelectionsChange}	
					currentSelections = {Object.values(attributes.selected_concepts)}					
				/>
				<h2 className={styles.blockSidebarHeader}>3. Set the display options</h2>
				<label className={styles.displayCheckBoxHolder}>Display default to open 
					<input
						type="checkbox"
						value={!attributes.defaultOpen}
						onChange={handleAttributes}
						name="defaultOpen"
						className={styles.blockConceptInputs}
						defaultChecked= {attributes.defaultOpen}
					/>
				</label>
				<label>Order the {pluralConcepts(attributes.concept)} by: 
					<SelectComponent
						value= {attributes.order_by}
						onChange={handleAttributes}
						name="order_by"
						className={styles.blockConceptInputs}
						options={[
							{value:'',label:''},
							{value:attributes.concept+'_local_numbering',label:'Local Numbering'},
							{value:attributes.concept,label:capitalize(attributes.concept)}
						]}
					/>
				</label>
				<label>Choose order: 
					<SelectComponent
						value= {attributes.ASC_DESC}
						onChange={handleAttributes}
						name="ASC_DESC"
						className={styles.blockConceptInputs}
						options={[
							{value:'ASC',label:'ASC'},
							{value:'DESC',label:'DESC'},
						]}
					/>
				</label>
				<label>Set the prefix that appears before each {attributes.concept} (can leave blank) 
					<input
						type="text"
						value={attributes.frontend_pre_fix}
						onChange={handleAttributes}
						name="frontend_pre_fix"
						className={styles.blockConceptInputs}
					/>
				</label>
				<label>Choose what to show, and the order
					<ControlPanelManager settings={controlSettings} setSettings={setControlSettings} holderAttributes={{className:styles.controlPanelManager}} />
				</label>
			</div>
		</InspectorControls>
	</ErrorBoundary>
	</div>;
}